import { useQuery } from '@tanstack/react-query'

import { GetDetalhesLoteService } from '@/features/empreendimentos/http'
import { produtosKeys } from '@/utils/produtos-query-keys'

export const useDetalhesLote = (idExterno: number) => {
  return useQuery({
    queryKey: produtosKeys.detalheLote(idExterno),
    queryFn: () => new GetDetalhesLoteService().execute(idExterno).then(({ data }) => data),
    enabled: idExterno > 0,
  })
}
